export const ModalSx = {
  width: '500px',
};
